/* global process */
let base = window._env_.VUE_APP_FIN_CENTER_HOST
export const getCompanyBankAccountTable = params => {
  return axios.post(`${base}/company-accounts/list`, params)
}

export const getCompanyBankAccountForSearch = params => {
  return axios.post(`${base}/company-accounts/query_remote_select`, params)
}

export const getCompanyBankAccountById = params => {
  return axios.get(`${base}/company-accounts/${params.id}`, {params})
}

// 移除删除接口
// export const delCompanyBankAccountById = params => {
//   return axios.delete(`${base}/company-accounts/${params.id}`, {params})
// }

export const enableCompanyBankAccount = params => {
  return axios.post(`${base}/company-accounts/${params.id}/enable`, params)
}

export const disableCompanyBankAccount = params => {
  return axios.post(`${base}/company-accounts/${params.id}/disable`, params)
}

export const createCompanyBankAccount = params => {
  return axios.post(`${base}/company-accounts`, params)
}

export const updateCompanyBankAccount = params => {
  return axios.put(`${base}/company-accounts/${params.id}`, params)
}



// WEBPACK FOOTER //
// ./src/views/company-bank-account/company-bank-account.api.js